import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import logo from "@/assets/logo.png";
import { useSiteSettings } from "@/hooks/use-site-settings";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { settings } = useSiteSettings();
  const socialLinks = [
    { label: "Facebook", href: settings.facebook_url, icon: Facebook },
    { label: "Instagram", href: settings.instagram_url, icon: Instagram },
    { label: "LinkedIn", href: settings.linkedin_url, icon: Linkedin },
    { label: "YouTube", href: settings.youtube_url, icon: Youtube },
    { label: "Twitter", href: settings.twitter_url, icon: Twitter },
  ].filter((link) => link.href);

  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src={logo} 
                alt="Abillyting Marketing Logo" 
                className="h-12 w-auto"
                width="48"
                height="48"
              />
              <span className="font-heading font-bold text-lg">
                Abillyting Marketing
              </span>
            </div>
            <p className="text-sm text-background/80">
              Agência especializada em marketing digital para petshops, casas de suplementos 
              e lojas de produtos naturais.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Serviços</h4>
            <ul className="space-y-2 text-sm text-background/80">
              <li>Social Media Pet & Nutrição</li>
              <li>Tráfego Pago Segmentado</li>
              <li>E-commerce Pet Shop</li>
              <li>Conteúdo Educativo</li>
              <li>Identidade Visual</li>
              <li>Campanhas Sazonais</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Empresa</h4>
            <ul className="space-y-2 text-sm text-background/80">
              <li>
                <a href="#sobre" className="hover:text-accent transition-colors">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#servicos" className="hover:text-accent transition-colors">
                  Nossos Serviços
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-accent transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#contato" className="hover:text-accent transition-colors">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Redes Sociais</h4>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((link) => <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" aria-label={link.label} className="w-10 h-10 rounded-full bg-background/10 hover:bg-accent flex items-center justify-center transition-colors"><link.icon size={20} /></a>)}
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-background/60">
            © {currentYear} Abillyting Marketing. Todos os direitos reservados.
          </p>
          <div className="flex space-x-6 text-sm text-background/60">
            <a href="#" className="hover:text-accent transition-colors">
              Política de Privacidade
            </a>
            <a href="#" className="hover:text-accent transition-colors">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;